import React, {useEffect, useRef, useState} from 'react';
import * as S from "../styles";
import {ReactComponent as IphoneImg} from '../images/iphone.svg?react';
import {ReactComponent as WebImg} from '../images/web.svg?react';
import useParallax from '../hooks/useParallax';

const WelcomeSection = ({ i18n, auth, isScrolled, onRegisterClick }) => {
    const {
        bgParallax,
        midParallax,
        fastParallax,
        reverseParallax,
        scrollProgress
    } = useParallax();

    const [isLoaded, setIsLoaded] = useState(false);
    const [functionsVisible, setFunctionsVisible] = useState(false);
    const functionsRef = useRef(null);

    useEffect(() => {
        // Триггерим начальные анимации после загрузки
        setIsLoaded(true);

        // Intersection Observer для анимации функций
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
                        setFunctionsVisible(true);
                    }
                });
            },
            {
                threshold: 0.3,
                rootMargin: '-50px 0px'
            }
        );

        if (functionsRef.current) {
            observer.observe(functionsRef.current);
        }

        return () => {
            if (functionsRef.current) {
                observer.unobserve(functionsRef.current);
            }
        };
    }, []);

    // Рассчитываем эффекты на основе прокрутки
    const titleScale = Math.max(1 - scrollProgress * 0.1, 0.9);
    const iphoneRotation = isScrolled ? -3 + (scrollProgress * 5) : scrollProgress * 5;
    const webScale = 1 + (scrollProgress * 0.05);

    return (
        <>
            <S.AnimatedWelcomeBlock id="top">
                <S.Wrap>
                    <S.ParallaxWelcomeTitle
                        style={{
                            transform: `translateY(${reverseParallax}px) scale(${titleScale})`,
                        }}
                        className={isLoaded ? 'loaded' : ''}
                    >
                        <h1>{i18n.mainPage?.mainTitle}</h1>
                        <p dangerouslySetInnerHTML={{ __html: i18n.mainPage?.mainTitle2 }} />
                        <p className='link'>
                            <a onClick={onRegisterClick}>
                                {i18n.auth.register}
                            </a>
                        </p>
                    </S.ParallaxWelcomeTitle>

                    <S.ParallaxWelcomeScreen>
                        <S.ParallaxWelcomeIphone
                            style={{
                                transform: `
                                translateY(${fastParallax * 0.3}px) 
                                translateX(${scrollProgress * -20}px)
                                rotate(${iphoneRotation}deg)
                            `
                            }}
                            className={isLoaded ? 'loaded' : ''}
                        >
                            <IphoneImg alt="iPhone app preview" />
                        </S.ParallaxWelcomeIphone>

                        <S.ParallaxWelcomeWeb
                            style={{
                                transform: `
                                translateY(${midParallax * 0.2}px) 
                                scale(${webScale})
                            `
                            }}
                            className={isLoaded ? 'loaded' : ''}
                        >
                            <WebImg alt="Web app preview" />
                        </S.ParallaxWelcomeWeb>
                    </S.ParallaxWelcomeScreen>
                </S.Wrap>
            </S.AnimatedWelcomeBlock>
            <S.AnimatedWelcomeFunction ref={functionsRef}>
                <S.Wrap>
                    <div>
                        <h2
                            className={functionsVisible ? 'visible' : ''}
                            dangerouslySetInnerHTML={{ __html: i18n.mainPage.functions }}
                        />
                        <S.AnimatedFunctions>
                            <div className={functionsVisible ? 'visible' : ''}>
                                {[1, 2, 3].map(num => (
                                    <div key={num}>
                                        {i18n.mainPage[`functions${num}`]}
                                    </div>
                                ))}
                            </div>
                            <div className={functionsVisible ? 'visible' : ''}>
                                {[4, 5, 6].map(num => (
                                    <div key={num}>
                                        {i18n.mainPage[`functions${num}`]}
                                    </div>
                                ))}
                            </div>
                        </S.AnimatedFunctions>
                    </div>
                </S.Wrap>
            </S.AnimatedWelcomeFunction>
        </>
    );
};

export default WelcomeSection;
